import { Skeleton } from '@/components/ui/skeleton'

export const CreateApiKeySheetFallback = () => (
  <div className="px-4 space-y-6">
    <div className="space-y-2">
      <Skeleton className="h-4 w-12 rounded" />
      <Skeleton className="h-10 w-full rounded-md" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-20 rounded" />
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-14 rounded-md" />
        ))}
      </div>
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-28 rounded" />
      <div className="grid grid-cols-2 gap-3">
        <Skeleton className="h-28 rounded-lg" />
        <Skeleton className="h-28 rounded-lg" />
      </div>
    </div>
  </div>
)
